import { useEffect } from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import { useIntl, FormattedMessage } from 'react-intl'
import { mdiArrowRight } from '@mdi/js'

import { useAppDispatch, useAppSelector } from 'app/hooks'
import routes from 'app/routes'
import CommonLinkButton from 'components/Button/CommonLinkButton'
import { homeActiveConfigSelector } from 'features/home/selectors'
import { useHomeRouteParams } from 'features/home/hooks'
import {
  ActiveConfigUpdatedButtonContainer,
  ActiveConfigurationContainer,
  ActiveConfigurationHeaderContainer,
  ActiveConfigLabelTime,
  ActiveConfigUpdatedLabelContainer,
  ActiveConfigurationButtonWrapper,
  ActiveConfigName,
} from './styles'
import { SubInfoBlock } from '../styles'
import { StyledIcon, SubInfoBlackCardDate } from '../../styles'
import { softwareVersionMessages } from '../../messages'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import { SpinnerCentered } from 'components/Loader'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import { DownloadButtonCell } from 'components/Table'
import {
  fetchHomeActiveConfigThunk,
  homeActiveConfigActions,
} from 'features/home/components/HomeConfiguration/slice'
import { cutLongTitle } from 'app/utils/cutLongTitle'

function ActiveConfiguration() {
  const history = useHistory()
  const { formatMessage } = useIntl()
  const { homeId } = useHomeRouteParams()
  const dispatch = useAppDispatch()

  const currentRootId = useAppSelector(currentRootDomainIdSelector)
  const isHomeActiveConfigLoaded = useAppSelector(
    homeActiveConfigSelector.isFinished
  )
  const homeActiveConfig = useAppSelector(homeActiveConfigSelector.data)

  const fileName = `${homeActiveConfig?.name}.tar.gz`

  useEffect(() => {
    if (homeId && !isHomeActiveConfigLoaded) {
      dispatch(
        fetchHomeActiveConfigThunk(homeId, {
          type: 'config',
          lastactive: true,
        })
      )
    }
  }, [dispatch, homeId, isHomeActiveConfigLoaded])

  useEffect(() => {
    return () => {
      dispatch(homeActiveConfigActions.clear())
    }
  }, [dispatch, homeId])

  const openActiveConfigurationPage = () => {
    if (currentRootId) {
      const homeConfigurationPath = generatePath(routes.homeConfiguration, {
        homeId,
        rootDomainId: currentRootId,
      })
      history.push(homeConfigurationPath)
    }
  }

  // TODO Add localization
  return isHomeActiveConfigLoaded ? (
    <ActiveConfigurationContainer>
      <ActiveConfigurationHeaderContainer>
        <FormattedMessage
          {...softwareVersionMessages.activeConfigurationLabel}
        />
        <CommonLinkButton onClick={openActiveConfigurationPage}>
          <StyledIcon path={mdiArrowRight} size={1} />
        </CommonLinkButton>
      </ActiveConfigurationHeaderContainer>
      <ActiveConfigName>
        {homeActiveConfig?.active
          ? cutLongTitle(homeActiveConfig?.name)
          : formatMessage(softwareVersionMessages.inactiveConfigurationLabel)}
      </ActiveConfigName>
      <ActiveConfigUpdatedButtonContainer>
        <ActiveConfigUpdatedLabelContainer>
          <ActiveConfigLabelTime>
            Updated&nbsp;
            <SubInfoBlackCardDate>
              <IntlFormattedDate date={homeActiveConfig?.updated} withTime />
            </SubInfoBlackCardDate>
          </ActiveConfigLabelTime>
        </ActiveConfigUpdatedLabelContainer>

        {homeActiveConfig?.active && homeActiveConfig?.location?.url && (
          <ActiveConfigurationButtonWrapper>
            <DownloadButtonCell
              url={homeActiveConfig.location.url}
              fileName={fileName}
            />
          </ActiveConfigurationButtonWrapper>
        )}
      </ActiveConfigUpdatedButtonContainer>
    </ActiveConfigurationContainer>
  ) : (
    <SubInfoBlock>
      <SpinnerCentered />
    </SubInfoBlock>
  )
}

export default ActiveConfiguration
